<div class="mb-4">
  <ngb-accordion (panelChange)="onPanelChange($event)" activeIds="ngb-panel-0">
    <ngb-panel>
      <ng-template ngbPanelHeader>
        <div class="row d-flex justify-content-between">
          <button ngbPanelToggle class="panel-header-content btn flex-grow-1 text-left">
            <h4 class="row">
              <span class="col-md-6 col-xl-5">Day {{dayNumber}} - {{eventDate.event_date_start | date:'M/d/y'}}</span>
              <span class="col-md-6 col-xl-7" *ngIf="eventDate.event_date_description">{{eventDate.event_date_description}}</span>
            </h4>
          </button>
          <button ngbPanelToggle class="text-right btn icon-btn">
            <i *ngIf="!previouslyPurchased" class="icon {{toggleIcon}}"></i>
            <i *ngIf="previouslyPurchased" class="icon icon-check-circle text-success"></i>
          </button>
        </div>
      </ng-template>

      <ng-template ngbPanelContent>
        <div *ngIf="!previouslyPurchased">
          <div *ngFor="let variant of licenseVariants" class="row px-2 mb-5" [ngClass]="{'disabled': optionDisabled(variant)}">
            <div class="col-md-6 col-lg-4">
              <h5>{{variant.title}}</h5>
              <p>{{variant.priceV2.amount | currency}} USD</p>
            </div>
            <div class="col-md-6 col-lg-5">
              <p>Based on your category you are considered a <strong>{{skillSummary.skill_text | uppercase}}</strong> rider for this event.</p>
            </div>
            <div class="col-md-5 col-lg-3 text-lg-right">
              <button class="btn {{btnClass(variant)}} btn-block"
                (click)="toggleControlValue(variant)"
                [disabled]="optionDisabled(variant)"
              >{{btnText(variant)}}</button>
            </div>
          </div>
        </div>
        <!-- One day already purchased -->
        <div *ngIf="previouslyPurchased">
          <h5 class="text-success">Ready to ride! You have already purchased a one day membership for this event date.</h5>
        </div>

      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>
